import { render, staticRenderFns } from "./buyOfficialCard.vue?vue&type=template&id=9fa946de&scoped=true"
import script from "./buyOfficialCard.vue?vue&type=script&lang=js"
export * from "./buyOfficialCard.vue?vue&type=script&lang=js"
import style0 from "./buyOfficialCard.vue?vue&type=style&index=0&id=9fa946de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa946de",
  null
  
)

export default component.exports